import { render, staticRenderFns } from "./activity_channel.vue?vue&type=template&id=3459515a&scoped=true&"
import script from "./activity_channel.vue?vue&type=script&lang=js&"
export * from "./activity_channel.vue?vue&type=script&lang=js&"
import style0 from "./activity_channel.vue?vue&type=style&index=0&id=3459515a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459515a",
  null
  
)

export default component.exports